import { Link } from "react-router-dom";
import { ReactSVG } from "react-svg";

const HomeQuickActions = () => {
    return (
        <div className="grid lg:grid-cols-4 md:grid-cols-3 grid-cols-2 gap-4">

            {/* مشاهده رزروهای من */}
            <Link 
                to="#my-reserve"
                onClick={(e) => {
                    e.preventDefault();
                    const el = document.getElementById("my-reserve");
                    if (el) {
                        el.scrollIntoView({ behavior: "smooth" });
                    }
                }}
                className="relative bg-white flex flex-col items-center justify-center shadow-custom-lg p-4 rounded-lg gap-3 border border-slate-100"
            >
                <ReactSVG 
                    src={`${process.env.PUBLIC_URL}/assets/images/icons/events.svg`} 
                    className="w-12 h-12 text-slate-400"
                />
                <span className="text-black text-[13px] font-medium">رزروهای من</span>
                <span className="absolute text-[11px] font-medium top-2 left-2 text-purple-700 bg-purple-100 rounded-full px-2 py-0.5">
                    مشاهده
                </span>
            </Link>

            {/* تماس با پشتیبانی */}
            <Link 
                to="/support"
                className="relative bg-white flex flex-col items-center justify-center shadow-custom-lg p-4 rounded-lg gap-3 border border-slate-100"
            >
                <ReactSVG 
                    src={`${process.env.PUBLIC_URL}/assets/images/icons/support.svg`} 
                    className="w-12 h-12 text-slate-400"
                />
                
                <span className="text-black text-[13px] font-medium">تماس با پشتیبانی</span>
                <span className="absolute text-[11px] font-medium top-2 left-2 text-blue-700 bg-blue-100 rounded-full px-2 py-0.5">
                    ارتباط
                </span>
            </Link>

        </div>
    );
};

export default HomeQuickActions;
